import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useState} from "react";
import InsertTemplateAcOne from "./InsertTemplateAcOne";
import IceButton from "../../components/Button";


export default function DialogInsertTemplate(props: any) {

    let {open, setOpen, setReturnObj, setCondObject, projUID} = props

    const formStyle: any = {
        display: 'grid',
        gridTemplateColumns: '95%',
        gridColumnGap: '20px',
        marginTop: '15px'
    }

    const [foundTemplate, setFoundTemplate] = useState<any>()

    function handleInsert() {
        if (foundTemplate) {
            setReturnObj(foundTemplate.returnObj)
            setCondObject(foundTemplate.condObj)
            setOpen(false)
        }
    }

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Use a Template/MappingUID</DialogTitle>
            <DialogContent>
                <DialogContentText style={{fontSize: '0.82rem'}}>
                    Insert a Template Name, Template UID or Feature Mapping UID:
                </DialogContentText>

                <div style={formStyle}>
                    <InsertTemplateAcOne
                        projUID={projUID}
                        setFoundTemplate={setFoundTemplate}
                    />
                </div>

            </DialogContent>
            <DialogActions>
                {/*<div style={{}}>*/}
                    <IceButton type="primary" text="Insert" onclick={handleInsert} />
                    <IceButton type="delete" text="Cancel" onclick={() => setOpen(false)} />
                {/*</div>*/}
                {/*MUI BUTTON --> <Button sx={{color: "#21409b !important"}} onClick={handleClose}>Close</Button>*/}
            </DialogActions>
        </Dialog>
    );
}
